import { Button } from "antd";
import {
  CurrencyFormat,
  formatDate,
  formatDate2,
} from "../../../../../../components/helpers";
import convertAddress from "../../../../../../components/helpers/convertAddress";

export const convertProcessLoanData = (
  loanData,
  loanSummary,
  handleOpenPreview
) => {
  let convertedProcessLoanData = {};
  if (!loanData && !loanSummary) return null;

  convertedProcessLoanData = {
    commonInfo: {
      id: loanData.customerID || "-",
      dueDate: formatDate(loanSummary.due_date) || "-",
    },
    headerInfo: {
      customerName: loanData.customerName || "-",
      customerEmail: loanData.customerEmail || "-",
      customerPicture: loanData.customerPicture || null,
      customerPhone1: loanData.customerPhone1 || "-",
      customerPhone2: loanData.customerPhone2 || "-",
      sbgCode: loanSummary.gadai_proof_code || "-",
      receiptNumber: loanSummary.receipt_code || "-",
      outletName: loanSummary.outlet_name || "-",
      status: loanData.status || "-",
    },
    loanInfo: {
      customerNIK: loanData.customerNIK || "-",
      customerGender: loanData.customerGender || "-",
      customerDOB: formatDate2(loanData.customerDOB) || "-",
      customerAddress: convertAddress(loanData.customer) || "-",
      customerKTPPicture: loanData.customerKTPPicture ? (
        <Button
          onClick={handleOpenPreview(
            `customer/${loanData.customerID}/ktp-picture`
          )}
          type="link"
          style={{ padding: 0 }}
        >
          Lihat Foto KTP
        </Button>
      ) : (
        "-"
      ),
      bankOrAccountNumber: loanData.bankOrAccountNumber || "-",
      accountName: loanData.accountName || "-",
      product: loanSummary.detail_product,
      transactionDate: formatDate(loanSummary.transaction_date) || "-",
    },
    loanSummary: {
      loanAmount: `Rp ${CurrencyFormat(loanSummary.loan_amount) || 0}` || "-",
      capitalLoan: `Rp ${CurrencyFormat(loanSummary.capital_loan) || 0}` || "-",
      feeAdmin: `Rp ${CurrencyFormat(loanSummary.fee_admin) || 0}` || "-",
      feeSavingAssurance:
        `Rp ${CurrencyFormat(loanSummary.fee_saving_assurance) || 0}` || "-",
      feeTransfer: `Rp ${CurrencyFormat(loanSummary.fee_transfer) || 0}` || "-",
      takenAmount: `Rp ${CurrencyFormat(loanSummary.taken_amount) || 0}` || "-",
    },
  };

  return convertedProcessLoanData;
};
